module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bw-0acc600b67ac7165e38c1f691d70c839.svg";